module.exports = __webpack_public_path__ + "img/LinkedIn.415247c1.jpg";